import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect, useRef, useState } from 'react';
import MyPageFilter from './MypageFilter';
import Footer from '../components/footer/Footer';
import RecentItem from './RecentItem';
import EditMyInfo from './editMyInfo/EditMyInfo';
import ScrollToTopButton from '../components/ScrollToTopButton';
import QuantReport from './QuantReport';
import CouponBox from './CouponBox';
import OneOnOneInquiry from './OneOnOneInquiry';
import Payment from './Payment';

const MyPage = () => {
  const [currentTab, setCurrentTab] = useState('관심물건');

  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
  const tabScrollRef = useRef<HTMLDivElement>(null);

  const tabItems = [
    {
      name: '관심물건',
      value: '관심물건',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'interest');
        setCurrentTab('관심물건');
      },
    },
    {
      name: '최근 열람 물건',
      value: '최근 열람 물건',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'recent');
        setCurrentTab('최근 열람 물건');
      },
    },
    // 마이페이지 퀀트 리포트
    {
      name: '퀀트 분석 리포트',
      value: '퀀트 분석 리포트',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'quant');
        setCurrentTab('퀀트 분석 리포트');
      },
    },
    {
      name: '쿠폰함',
      value: '쿠폰함',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'coupon');
        setCurrentTab('쿠폰함');
      },
    },
    {
      name: '결제내역',
      value: '결제내역',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'payment');
        setCurrentTab('결제내역');
      },
    },
    {
      name: '1:1 문의하기',
      value: '1:1 문의하기',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'inquiry');
        setCurrentTab('1:1 문의하기');
      },
    },
    {
      name: '내 정보 수정',
      value: '내 정보 수정',
      onclick: () => {
        sessionStorage.setItem('mypageTab', 'myinfo');
        setCurrentTab('내 정보 수정');
      },
    },
  ];

  const mypageTab = sessionStorage.getItem('mypageTab');

  useEffect(() => {
    if (mypageTab && mypageTab === 'interest') {
      setCurrentTab('관심물건');
    }

    if (mypageTab && mypageTab === 'recent') {
      setCurrentTab('최근 열람 물건');
    }

    if (mypageTab && mypageTab === 'myinfo') {
      setCurrentTab('내 정보 수정');
    }

    if (mypageTab && mypageTab === 'payment') {
      setCurrentTab('결제내역');
    }

    if (mypageTab && mypageTab === 'inquiry') {
      setCurrentTab('1:1 문의하기');
    }

    if (mypageTab && mypageTab === 'quant') {
      setCurrentTab('퀀트 분석 리포트');
    }
    if (mypageTab && mypageTab === 'coupon') {
      setCurrentTab('쿠폰함');
    }
  }, [mypageTab]);

  const renderContent = () => {
    if (currentTab === '관심물건') {
      return <MyPageFilter />;
    }
    if (currentTab === '최근 열람 물건') {
      return <RecentItem />;
    }
    if (currentTab === '퀀트 분석 리포트') {
      return <QuantReport />;
    }
    if (currentTab === '1:1 문의하기') {
      return <OneOnOneInquiry />;
    }
    if (currentTab === '결제내역') {
      return <Payment />;
    }
    if (currentTab === '쿠폰함') {
      return <CouponBox />;
    } else {
      return <EditMyInfo />;
    }
  };

  const scrollTabIntoCenter = () => {
    const index = tabItems.findIndex((item) => item.value === currentTab);
    const tabEl = tabRefs.current[index];
    const scrollContainer = tabScrollRef.current;

    if (tabEl && scrollContainer) {
      const scrollOffset =
        tabEl.offsetLeft -
        scrollContainer.clientWidth / 2 +
        tabEl.clientWidth / 2;

      scrollContainer.scrollTo({ left: scrollOffset, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollTabIntoCenter();
    window.scrollTo(0, 0);
  }, [currentTab]);

  return (
    <Container>
      <ScrollToTopButton></ScrollToTopButton>
      <PageTop text="마이페이지" />
      <TabBox ref={tabScrollRef}>
        <TabInner>
          {tabItems.map((tab, index) => (
            <Tab
              key={index}
              ref={(el) => {
                tabRefs.current[index] = el;
              }}
              active={currentTab === tab.value}
              onClick={tab.onclick}
            >
              {tab.name}
            </Tab>
          ))}
        </TabInner>
      </TabBox>
      {renderContent()}
      <Footer />
    </Container>
  );
};
export default MyPage;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  font-family: Spoqa Han Sans Neo;
`;

const TabBox = styled.div`
  width: 100%;
  position: sticky;
  top: 56px;
  max-width: inherit;
  background-color: #fff;
  z-index: 1000;
  overflow-x: auto;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

const TabInner = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  white-space: nowrap;

  &::after {
    content: '';
    flex: 0 0 10px;
  }
`;

const Tab = styled.div<{ active?: boolean }>`
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#ffffff' : '#989BA2')};
  background-color: ${(props) =>
    props.active ? '#222222' : 'rgba(112, 115, 124, 0.08)'};
  border-radius: 9999px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
`;
